import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Addresses_ds_get_contact_by_addressIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { addressId: number }): 
  Promise<{ result: { Id?: number, AddressId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.addressId)) {
      $missingRequiredInParams.push('\'addressId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { addressId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, AddressId?: number }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.addressId)) {
      $missingRequiredInParams.push('\'addressId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { addressId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, AddressId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.addressId)) {
      $missingRequiredInParams.push('\'addressId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      addressId: number    }) {
        if(isNil($inParams.addressId)) {
          return true; 
        }
      return false;
    }
}
